import EventStatus from './Styles';

export default EventStatus;
